export default {
  sent: 'Facturas enviadas:',
  treatPending: 'Facturas pendientes de tratar',
  sentPending: 'Facturas pendientes de enviar',
  max: 'de máximo',
  barChart: 'Facturas intercambiadas',
  pieChart: 'Estados de las facturas'
}
